import { unstable_ClassNameGenerator as ClassNameGenerator } from "@mui/material/className";

// Prefix v5 classes so they do not collide with the portal's v4 styles.
ClassNameGenerator.configure(componentName => `mui5-${componentName}`);
